/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WeeklyStatisticModel } from '../../models/weekly-statistic-model';

export interface IntegrationWeeklyStatisticsSystemIdentifierIdGet$Params {

/**
 * The unique identifier of the system
 */
  systemIdentifierId: string;

/**
 * The start date for the statistics period
 */
  fromDate?: string;

/**
 * The end date for the statistics period
 */
  toDate?: string;
}

export function integrationWeeklyStatisticsSystemIdentifierIdGet(http: HttpClient, rootUrl: string, params: IntegrationWeeklyStatisticsSystemIdentifierIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<Array<WeeklyStatisticModel>>> {
  const rb = new RequestBuilder(rootUrl, integrationWeeklyStatisticsSystemIdentifierIdGet.PATH, 'get');
  if (params) {
    rb.path('systemIdentifierId', params.systemIdentifierId, {});
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<Array<WeeklyStatisticModel>>;
    })
  );
}

integrationWeeklyStatisticsSystemIdentifierIdGet.PATH = '/Integration/WeeklyStatistics/{systemIdentifierId}';
